
export default {
    name: 'activity',
    props: ['source'],
    data() {
        return {
            day: '',
            hour: '',
            minute: '',
            second: ''
        }
    },
    async fetch() {
        if (this.source.activityStatus.id == 1) {
            let nowtime = new Date();  //获取当前时间'
            let endtime = new Date(this.source.end_time);  //定义结束时间
            let str = parseInt(this.source.end_time) * 1000;
            let lefttime = str - nowtime.getTime(); //距离结束时间的毫秒数
            let leftd = Math.floor(lefttime / (1000 * 60 * 60 * 24)); //计算天数
            let lefth = Math.floor(lefttime / (1000 * 60 * 60) % 24);  //计算小时数
            let leftm = Math.floor(lefttime / (1000 * 60) % 60);  //计算分钟数
            let lefts = Math.floor(lefttime / 1000 % 60);  //计算秒数
            this.day = leftd
            this.hour = lefth
            this.minute = leftm
            this.second = lefts
        }
    },
    watch: {
        source(val) {
            this.source = val
        }
    },
    computed: {
        sumDays(){
            const startDate = new Date(this.source.start_time * 1000); // 将秒转换为毫秒
            const endDate = new Date(this.source.end_time * 1000); // 将秒转换为毫秒
            // 获取两个日期之间的毫秒差
            const diffInMilliseconds = endDate - startDate;
            // 将毫秒差转换为天
            const diffInDays = Math.ceil(diffInMilliseconds / (1000 * 60 * 60 * 24));
            return diffInDays+' days';
        }
    },
    mounted() {
        let time = setInterval(() => {
            if (this.source.activityStatus.id == -1) {
                clearInterval(time)
            }
            this.showTime()
        }, 1000)
    },
    methods: {
        async collectOperation() {
            //收藏 取消收藏
            //type 1作品收藏 3资讯收藏 5活动收藏 9帖子收藏 10教程收藏
            //is_collect 0是收藏1取消收藏
            let res = await this.$global.do_collect({ "relation_id": this.source.id, "type": "5", "is_collect": this.source.is_collect })
            console.log(res, 'res')
            if (res.code == 200) {
                this.source.is_collect = !this.source.is_collect
                this.$message({
                    showClose: true,
                    message: res.msg
                });
            }

        },
        // 倒计时
        showTime() {
            if (this.source.activityStatus.id == 1) {
                let nowtime = new Date();  //获取当前时间'
                let endtime = new Date(this.source.end_time);  //定义结束时间
                let str = parseInt(this.source.end_time) * 1000;
                let lefttime = str - nowtime.getTime(); //距离结束时间的毫秒数
                let leftd = Math.floor(lefttime / (1000 * 60 * 60 * 24)); //计算天数
                let lefth = Math.floor(lefttime / (1000 * 60 * 60) % 24);  //计算小时数
                let leftm = Math.floor(lefttime / (1000 * 60) % 60);  //计算分钟数
                let lefts = Math.floor(lefttime / 1000 % 60);  //计算秒数

                this.day = leftd
                this.hour = lefth
                this.minute = leftm
                this.second = lefts
            }
        }
    }
}
